import { Link } from "react-router-dom"
import Card from "../../components/Card"
import { Button, Popconfirm, Spin, Table, message } from "antd"
import { useContext, useEffect, useState } from "react"
import { AuthService } from "../../services/AuthService"
import Title from "antd/es/typography/Title"
import LayoutContext from "../../context/layoutContext"
import { DeleteOutlined } from "@ant-design/icons"
import { UserContext } from "../../context/userContext"

const Categories = () => {

    const {  role: ROLE } = useContext(LayoutContext);
    const [messageApi, contextHolder] = message.useMessage();
  const {  user } = useContext(UserContext);
    
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);

    const [columns, setColumns] = useState([
        {
            title: 'Emri',
            dataIndex: 'categoryName',
            key: 'categoryName',
            width: 150, // Set the fixed width for the column
        },
        ...(user?.details?.roleName === 'Admin' ? [{
            title: 'ACTIONS',
            dataIndex: 'actions',
            key: 'actions',
            width: 80,
            render: (_, record) => {
              return (
                <Popconfirm
                  title="Fshij brendin"
                  description="A jeni i sigurte per veprimin?"
                  okText="Po"
                  cancelText="Anulo"
                  onConfirm={() => deleteCategory(record)}
                >
                  <Button type="primary" danger size="small"><DeleteOutlined /></Button>
                </Popconfirm>
              );
            },
          }] : [])
    ])


    const getCategories = async () => {
        setLoading(true);
        let res = await AuthService.getCategories({});
        console.log("res", res);
        if (res?.items && res?.items.length > 0) {
            setCategories(res?.items);
        }
        setLoading(false);
    }

    const deleteCategory = async (record) => {
        console.log("dete", record.categoryId)
     
       if(!record?.categoryId) return;
     
         let res = await AuthService.deleteCategory(record?.categoryId);
         console.log("deleted res", res);
         if(res){
           messageApi.open({
             type: 'success',
             content: 'Brendi u fshi me sukses!',
         });
         getCategories();
         }
       }

    useEffect(() => {
        getCategories();
    }, [])

    return (
        <div className="container">
            <div className="d-flex justify-content-between align-items-center mb-2">
                <Title level={4} style={{ fontWeight: '400', fontFamily: 'Source Sans 3' }}>Kategorite</Title>
                <Link to="/categories/new" style={{ display: "flex" }}>
                    <Button type="primary">Shto një të ri</Button>
                </Link>
            </div>
            {categories && <Spin spinning={loading} tip="Duke procesuar te dhenat..."><Table dataSource={categories} size="small" columns={columns} style={{ marginTop: 20 }} /> </ Spin>}

        </div>
    )
}

export default Categories